import * as $ from 'jquery';

export class Exam {
    constructor() {
        $('A').on("click", function () {
            if (confirm("To complete this course, you must take the final exam and click SCORE EXAM when you are done. Are you sure you want to exit this page?")) {
                return true;
            }
            else {
                return false;
            }
        });
        // hide validation class
        $('.answers input').on("click", function () {
            $(this).closest('.input-validation-error').removeClass('input-validation-error');
        });
    }
}


